import React, { useState } from "react";
import { Card, Form, Button, Row, Col } from "react-bootstrap";
import { FaTrashAlt, FaFilePdf, FaPlus } from "react-icons/fa";
import "./SuppliersConsult.scss";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  useGetSupplierByIdAndCompanyIdQuery,
  useGetUsersSuppliersQuery,
} from "store/supplier/supplier.api";
import { BASE_URL } from "config/config";
import CreateSupplierUserModal from "@components/CreateSupplierUserModal/CreateSupplierUserModal";
import { useDeleteUserMutation } from "store/user/userApi";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const SuppliersConsult = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;

  const { data: supplier, isLoading: isLoadingSupplier } =
    useGetSupplierByIdAndCompanyIdQuery({ supplierId: id, companyId });

  const [showModal, setShowModal] = useState(false);

  const {
    data: users,
    isLoading,
    error,
    refetch,
  } = useGetUsersSuppliersQuery({
    supplierId: id,
    companyId: companyId,
  });

  const [deleteUser] = useDeleteUserMutation();

  function getImageURL(id) {
    return `${BASE_URL}documentsFile/${id}/file`;
  }

  const handleDelete = async (userId) => {
    try {
      await deleteUser(userId).unwrap();
      toast.success(t("supplierConsult.form.delete_success"));
      refetch();
    } catch (err) {
      console.error(err);
      toast.error(t("supplierConsult.form.delete_error"));
    }
  };

  return (
    <div className="department-section container-fluid">
      <Row>
        {/* Colonne gauche : fournisseur */}
        <Col md={6}>
          <Card className="section-card">
            <Card.Body>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("supplierConsult.form.supplier_name")}{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" defaultValue={supplier?.data?.name} />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>{t("supplierConsult.form.email")}</Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={supplier?.data?.email}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>{t("supplierConsult.form.telephone")}</Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={supplier?.data?.telephone}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>{t("supplierConsult.form.address")}</Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={supplier?.data?.address}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>{t("supplierConsult.form.documents")}</Form.Label>
                <div className="doc-list">
                  {[
                    "idDocumentfiscalDoc",
                    "idDocumentkbis",
                    "idDocumenturssafDoc",
                  ].map((docKey) => {
                    const doc = supplier?.data?.[docKey];
                    if (!doc) return null;
                    return (
                      <div key={docKey} className="doc-item">
                        <FaFilePdf className="pdf-icon" />
                        <span className="doc-name">
                          <a
                            href={getImageURL(doc._id)}
                            target="_blank"
                            className="doc-name"
                            rel="noopener noreferrer">
                            {doc.title}
                          </a>
                        </span>
                        <span className="doc-date">
                          {new Date(doc.createdAt).toLocaleDateString()}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        {/* Colonne droite : Membres */}
        <Col md={6}>
          <Card className="shadow-sm section-card">
            <Card.Body>
              <h6>{t("supplierConsult.form.collaborators")}</h6>
              <div className="members-list">
                {users?.data?.map((user) => (
                  <div key={user._id} className="member-item">
                    <span>
                      {user.name} ({user.email})
                    </span>
                    <FaTrashAlt
                      className="delete-icon"
                      onClick={() => handleDelete(user._id)}
                    />
                  </div>
                ))}
              </div>

              <div className="mt-3 d-flex gap-3">
                <Button variant="primary" onClick={() => setShowModal(true)}>
                  <FaPlus /> {t("supplierConsult.form.add_collaborator")}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal pour créer utilisateur fournisseur */}
      <CreateSupplierUserModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        supplierId={id}
        companyId={companyId}
      />
    </div>
  );
};

export default SuppliersConsult;
